import type { ReactNode } from "react";

export interface ContactChannelProps {
  icon: ReactNode;
  label: string;
  value: string;
}

/**
 * Un dato de contacto: icono, qué es y su valor. Se repite tres veces en
 * la columna izquierda, así que es un componente y no tres bloques
 * idénticos de JSX.
 */
export function ContactChannel({ icon, label, value }: ContactChannelProps) {
  return (
    <div className="flex items-center gap-4">
      <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-ds-md border border-ds-border bg-white text-ds-violet-pop [&>svg]:h-5 [&>svg]:w-5">
        {icon}
      </span>
      <div className="min-w-0">
        <p className="text-[10px] font-semibold uppercase tracking-ds-label-wide text-ds-ink-3">
          {label}
        </p>
        <p className="truncate text-[14px] font-medium text-ds-ink">{value}</p>
      </div>
    </div>
  );
}
